<template>
  <div v-if="!hiddenKeys.includes(title)" class="displayItem">
    <div class="title" v-if="!noTitle">{{ title }}:</div>
    <div class="content" :class="itemType">
      <p v-if="itemType === 'string'"> {{item}}</p>
      <p v-if="itemType === 'boolean'"> {{(item)? 'Yes' : 'No' }}</p>
      <div v-if="itemType === 'object'">
        <div v-for="(obj,key, index) in item" :key="index">
          <s-g-a-display-item :item="obj" :title="key" :noTitle="Number.isInteger(key)"></s-g-a-display-item>
        </div>        
      </div>
      <div v-if="itemType === 'array'">
        <div v-for="(obj,key, index) in item" :key="index">
          <s-g-a-display-item :item="obj" :title="key" :noTitle="true"></s-g-a-display-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EmpDisplayItem',
  props: [
    'item',
    'title',
    'noTitle'
  ],
  data() {
    return {
      hiddenKeys: [
        'IsComplete',
        'EmployeeRoleONETCode',
        'SelectedCultureOptions'
      ],
    };
  },
  computed: {
    itemType() {
      return typeof this.item;
    }
  },
};
</script>
<style lang="scss">
  .displayItem {
    margin-left: 20px;
  }
</style>